import { render, staticRenderFns } from "./InfoField.vue?vue&type=template&id=4ad2bdee&scoped=true&"
import script from "./InfoField.vue?vue&type=script&lang=ts&"
export * from "./InfoField.vue?vue&type=script&lang=ts&"
import style0 from "./InfoField.vue?vue&type=style&index=0&id=4ad2bdee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2bdee",
  null
  
)

export default component.exports